/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Component, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-busydialog',
    templateUrl: './busydialog.component.html',
    styleUrls: ['./busydialog.component.less'],
})
export class BusydialogComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal) {}

    @Input() resolve: any

    public completed = false
    public error = false
    public messages = []
    public title = ''

    ngOnInit(): void {
        let vm = this
        vm.resolve.value.then(
            function (result: any) {
                vm.messages = result.messages || []
                if (vm.resolve.successTitle) {
                    vm.title = vm.resolve.successTitle
                }
                vm.completed = true

                if (!vm.resolve.acknowledgeCompletion) {
                    // Close automatically after the user has had a chance
                    // to see the "success" indicator
                    setTimeout(function () {
                        vm.activeModal.close({ $value: result })
                    }, 1000)
                }
            },
            function (result: any) {
                vm.error = result.error
                vm.messages = result.messages || []
                vm.title = vm.resolve.errorTitle
                vm.completed = true
            }
        )
    }

    trackByIndex = (index: number): number => {
        return index
    }
}
